import React from "react";
import "./App.css";

function Bio() {
  return (
    <div>
      {/* ? Header */}
      <div className="row">
        <header className="header">
          <nav className="navbar navbar-expand-lg py-3 fixed-top">
            <div className="container">
              <div className="d-flex justify-content-center align-items-center">
                <a
                  className="nav-logo m-0 mx-0 me-lg-3 p-0 text-decoration-none me-md-3"
                  href="/home">
                  HipHop
                </a>
                <img
                  src="./images/svg/cd.svg"
                  alt="cd"
                  id="cd"
                  className="m-0 px-0 d-none d-lg-block d-md-block d-sm-block"
                />
              </div>

              <button
                className=" navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span className="navbar-toggler-icon rounded rounded-1 "></span>
              </button>

              <div className="collapse navbar-collapse me-lg-3" id="navbarNav">
                <ul className="nav-ul navbar-nav mx-auto me-0 pe-3 align-items-md-center align-items-center">
                  <li className="mt-md-4 mt-sm-3 mt-4 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/home">
                      Inicio
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/videos">
                      Video clips
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/disc">
                      Discografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/bio">
                      Biografía
                    </a>
                  </li>
                  <li className="mt-md-3 mt-sm-3 mt-3 m-lg-0 mt-sm-3 nav-item">
                    <a
                      className="px-lg-4 px-md-5 px-sm-5 px-5 nav-link"
                      aria-current="page"
                      href="/eventos">
                      Eventos
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      </div>

      {/* ? Contenido */}
      <div className="bio container-lg container-md">
        <div className="bio-title_group text-center pt-lg-4 pt-md-4 pt-sm-4 pt-1">
          <h2>Biografía</h2>
        </div>

        <div className="mena container-lg container-md mt-lg-5 py-lg-4 mt-md-1 py-md-4 mt-sm-1 py-sm-3 mt-2 py-3">
          <div className="right">
            <h2 className="bio-title_mena text-center">Turkano</h2>
            <h4 className="bio-data_mena text-start">19-1-17</h4>
            <p className="bio-text_mena">
              Jonathan Alexander Mena Salcedo, conocido artísticamente como
              Turkano, nació el 12 de noviembre de 1991 en Medellín, Colombia.
              Creció en el municipio de Chigorodó y actualmente reside en
              Medellín. Su nombre artístico surge como homenaje a la tribu
              africana Turkana y a las manifestaciones culturales afro que han
              influenciado su identidad y visión artística.
            </p>
            <p className="bio-text_mena">
              Desde los 12 años encontró en el rap una forma de expresión,
              inspirado por artistas y referentes del hip hop como Vico C, 2Pac,
              Snoop Dogg y Eminem. Con el tiempo, desarrolló un estilo marcado
              por la influencia del G-funk y el sonido clásico de la costa oeste
              de California, fusionando melodías urbanas con letras
              introspectivas y narrativas.
            </p>
            <p className="bio-text_mena">
              Además de su habilidad para la escritura lírica, Turkano se ha
              destacado por su capacidad para el freestyle y por construir
              proyectos conceptuales que van más allá de la música tradicional.
              Canciones como "Mulata", "Microphone Killa", "Get the Money" y
              "Gangsta Feeling" le han permitido ganar reconocimiento local y
              conectar con una audiencia que valora tanto el sonido como el
              mensaje detrás de sus composiciones.
            </p>
            <p className="bio-text_mena">
              En 2026 presentó El Show Debe Continuar, un proyecto experimental
              que transformó un álbum musical en una experiencia narrativa e
              interactiva. A través de pistas ocultas, storytelling y una
              plataforma digital, los oyentes debían descifrar la historia
              detrás de las canciones, consolidando a Turkano como un artista
              independiente enfocado en crear universos artísticos donde
              convergen la música, la psicología, la tecnología y el cine.
            </p>
            <p className="bio-text_mena">
              Actualmente, Turkano trabaja en la expansión de este universo
              creativo hacia el ámbito cinematográfico, desarrollando una
              adaptación audiovisual basada en la historia de El Show Debe
              Continuar, con el objetivo de seguir explorando nuevas formas de
              conectar emocionalmente con el público a través del arte y la
              narrativa.
            </p>
          </div>

          <div className="bio-img_mena left ms-lg-3">
            <img
              src="./images/jpg/bio-mena.jpg"
              alt="Foto de Turkano"
              className="d-none d-sm-none d-md-none d-lg-block"
            />
          </div>
        </div>
      </div>

      {/* ? Pie  */}
      <footer className="footer">
        <div className="container d-flex flex-column align-items-center p-3 pb-0">
          <h1 className="footer-title text-center">
            Escúchanos en <br /> <span className="">Plataformas</span>
          </h1>

          <div className="footer-imgs d-flex justify-content-around w-75 mt-4">
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/youtube-f-w.svg"
                alt="YouTube"
                width="170"
                title="YouTube"
                id="img-yt"
              />
            </a>
            <a
              href="https://youtube.com/@19117records?si=gelRCvPFXe9EEjgH"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/yt_music-f-w.svg"
                alt="YouTube Music"
                width="80"
                title="YouTube Music"
              />
            </a>
            <a
              href="https://open.spotify.com/intl-es/artist/4xU5vqImsU2aw0egTk7p68?si=HFFGGeUcR2i29alfqrSfUg"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/spotify-f-w.svg"
                alt="Spotify"
                width="80"
                title="Spotify"
              />
            </a>
            <a
              href="https://link.deezer.com/s/33gNTeFkFpklf7NWxT4D7"
              target="_blank"
              rel="noreferrer">
              <img
                src="/images/svg/deezer-f-w.svg"
                alt="Deezer"
                width="80"
                title="Deezer"
              />
            </a>
          </div>


          <div className="comunication w-50 d-lg-flex justify-content-around align-items-center py-3 pb-5 d-grid col-1">
            <div className="footer-contact text-center">
              <h2>Contacto</h2>
              <p>19117records@gmail.com</p>
              <p>3146148505</p>
            </div>
          </div>
        </div>

        <div className="copy d-flex justify-content-between mx-3 fs-6">
          <p>2023, &copy; TURKANO</p>
          <p className="otto text-uppercase">&copy; OTTO | Carlos Arteaga</p>
        </div>
      </footer>
    </div>
  );
}

export default Bio;
